import { Component } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";

import {
  DKIcons,
  DKIcon,
  DKButton,
  DKLabel,
  DKStatus,
  showToast,
  TOAST_TYPE,
  DKTooltipWrapper,
} from "deskera-ui-library";
import ApiConstants from "../../constants/ApiConstants";
import AppManager from "../../managers/AppManager";
import FeedbackPopup from "../common/FeedbackPopup";
import ic_credit_card from "../../assets/icons/ic_credit_card.png"
import SelectOrganisation from "../common/SelectOrganisation";
import TenantManager from "../../managers/TenantManager";
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import { CONSTANTS } from "../../constants/Constant";
import ic_copy from "../../assets/icons/ic_copy.png";
import { isIndiaCompliance } from "../../managers/common/CommonUtil";
import UserPermissions from "../user-permissions/UserPermissions";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ModuleAccessControl from "../module-access-control/ModuleAccessControl";
import PermissionUtils from "../user-permissions/PermissionUtils";
import DropdownManagement from "../dropdown-management/DropdownManagement";

export const SETTING_CARD = {
    MY_PROFILE: 'my_profile',
    USER_PERMISSIONS: 'user_permissions',
    MODULE_ACCESS_CONTROL: 'module_access_control',
    ORGANIZATION_SETTINGS: 'organization_settings',
    USER_MANAGEMENT: 'user_management',
    PERMISSIONS: 'permissions',
    SUBSCRIPTION_BILLING: 'subscription_billing',
    TWO_FACTOR_AUTH: 'two_factor_auth',
    CHANGE_PASSWORD: 'change_password',
    CONFIG_PAYMENT_ACCOUNT: 'config_payment_account',
    CHOOSE_PAYMENT_OPTION: 'choose_payment_option',
    SEQUENCE_NUMBER_SETTINGS: 'sequence_number_settings',
    AUDIT_LOGS: 'audit_logs',
    DROPDOWN_MANAGEMENT: 'dropdown_management'
};

export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.settingOptions = [
      {
        id: SETTING_CARD.MY_PROFILE,
        title: "My Profile",
        description: "See your profile details and explore our other products too",
        icon: DKIcons.ic_user,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO,
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.USER_PERMISSIONS,
        title: "User Permissions",
        description: "Invite new users to your org and manage user permissions.",
        icon: DKIcons.ic_user_2,
        iconTitle: "",
        url: "USER_PERMISSIONS",
        buttonTitle: "Edit Permissions",
        navigateTo: false,
        hasInfo: false,
        isVisible: TenantService.get(TENANT.IS_OWNER),
        redirectTo: "_self",
      },
      {
        id: SETTING_CARD.MODULE_ACCESS_CONTROL,
        title: "Module Access Control",
        description: "Restrict module access settings.",
        icon: DKIcons.ic_user_2,
        iconTitle: "",
        url: "MODULE_ACCESS_CONTROL",
        buttonTitle: "View details",
        navigateTo: false,
        hasInfo: false,
        isVisible: TenantService.get(TENANT.IS_OWNER),
        redirectTo: "_self",
      },
      {
        id: SETTING_CARD.ORGANIZATION_SETTINGS,
        title: "Organization settings",
        description: "You can update or modify your organisation details here",
        icon: DKIcons.ic_home,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO + "settings",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.USER_MANAGEMENT,
        title: "User Management",
        description: "Add or modify users to your organisation. Users will be listed here",
        icon: DKIcons.ic_user_2,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO + "users",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.PERMISSIONS,
        title: "Permissions",
        description: "Assign roles and permission to oraganisation's user different products",
        icon: DKIcons.ic_lock,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO + "users",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.SUBSCRIPTION_BILLING,
        title: "Subscription / Billing",
        description: "Manage your subscription, change plan and upgrade here",
        icon: DKIcons.ic_cards,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO + "billing",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.TWO_FACTOR_AUTH,
        title: "Two-Factor Authentication (2FA)",
        description: "Increase your account's security by enabling Two-Factor Authentication (2FA).",
        icon: DKIcons.ic_key,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO + "security",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.CHANGE_PASSWORD,
        title: "Change Password",
        description: "You can change or modify your password here",
        icon: DKIcons.ic_key_2,
        iconTitle: "",
        url: ApiConstants.PRODUCT_URL_GO + "security",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_blank",
      },
      {
        id: SETTING_CARD.CONFIG_PAYMENT_ACCOUNT,
        title: "Connect Your Deskera Account",
        description: "You need to connect your Deskera People account first by authenticating",
        icon: ic_credit_card,
        iconTitle: "Configure Payment Account",
        url: ApiConstants.MULTI_PAYMENT + "cashfree",
        buttonTitle: "View details",
        navigateTo: true,
        hasInfo: true,
        infoObject: this.getInfoObjectForCashfree(),
        isVisible: isIndiaCompliance(),
        redirectTo: "_self",
      },
      {
        id: SETTING_CARD.SEQUENCE_NUMBER_SETTINGS,
        title: 'Sequence Number Settings',
        description: 'Set default document number sequencing',
        icon: DKIcons.ic_cards,
        iconTitle: "",
        url: "/sequence",
        buttonTitle: "View details",
        navigateTo: false,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_self",
      },
      {
        id: SETTING_CARD.AUDIT_LOGS,
        title: 'Audit Logs',
        description: 'View all of your audit logs here.',
        icon: DKIcons.ic_document,
        iconTitle: "",
        url: PAGE_ROUTES.AUDIT_LOGS,
        buttonTitle: "View details",
        navigateTo: false,
        hasInfo: false,
        isVisible: true,
        redirectTo: "_self"
      },
      {
        id: SETTING_CARD.DROPDOWN_MANAGEMENT,
        title: 'Dropdown Management',
        description: 'Manage all dropdown options from here.',
        icon: DKIcons.ic_settings,
        iconTitle: "",
        url: 'DROPDOWN_MANAGEMENT',
        buttonTitle: 'View details',
        navigateTo: false,
        hasInfo: false,
        isVisible: TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED),
        redirectTo: '_self'
      }
    ];

    this.state = {
      needFeedbackPopup: false,
      showSelectOrgPopUp: false,
      showUserPermissionsPopup: false,
      showModuleAccessControlPopup: false,
      showDropdownManagementPopup: false,
    };
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
  }

  getInfoObjectForCashfree() {
    let values = {};
    let tenantData = TenantManager.getPeopleTenantData();
    if (tenantData && tenantData.tenant) {
      if (tenantData.tenant.isCashfreeEnabled) {
        values["isCashFreeConnected"] = tenantData.tenant.isCashfreeEnabled;
      }
    }
    values["infoText"] = CONSTANTS.CASHFREE_INFO_TEXT;
    values["whiteListIp"] = ApiConstants.CASHFREE_WHITELIST_IP.split(";");
    values["webhooks"] = ApiConstants.CASHFREE_WEBHOOKS;
    values["ipRedirectUrl"] = ApiConstants.CASHFREE_WHITELIST_REDIRECT;
    values["webhooksRedirectUrl"] = ApiConstants.CASHFREE_WEBHOOKS_REDIRECT;
    return values;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <div className="parent-width">
        <DKLabel className="fs-l fw-m" text="Settings" />
        {this.getHelpSection()}
        <div className="row flex-wrap mt-l align-items-stretch">
          {this.getAllCards()}
        </div>
        {this.getFooter()}
        {this.state.needFeedbackPopup && (
          <FeedbackPopup onCancel={this.hideFeedbackPopup} />
        )}
        {/* <FeedbackPopup onCancel={this.hideFeedbackPopup}></FeedbackPopup> */}
        {this.state.showSelectOrgPopUp && (
          <SelectOrganisation
            onCancel={this.hideSelectOrgPopup}
            {...this.props}
          />
        )}
        {this.state.showUserPermissionsPopup && (
            <UserPermissions
                {...this.props}
                onClose={() => {
                    this.setState({ showUserPermissionsPopup: false });
                }}
            />
        )}
        {this.state.showModuleAccessControlPopup && (
          <ModuleAccessControl
            onClose={() => {
                this.setState({ showModuleAccessControlPopup: false });
            }}
          />
        )}
        {this.state.showDropdownManagementPopup && (
          <DropdownManagement
            onClose={() => {
              this.setState({ showDropdownManagementPopup: false });
            }}
          />
        )}
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getAllCards() {
    const filteredCards = this.settingOptions.filter((card) => {
        if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
            if (TenantService.get(TENANT.IS_OWNER)) {
                return card.isVisible;
            }
            return PermissionUtils.hasPermissionForSettingCard(card.id);
        } else {
            return card.isVisible;
        }
    });

    return filteredCards.map((card) => this.getCard(card));
  }

  routeToPage(url, navigateTo, redirectTo) {
    if (navigateTo) {
        window.open(url, redirectTo);
    } else {
        switch (url) {
            case "USER_PERMISSIONS":
                this.setState({
                    showUserPermissionsPopup: true
                });
                break;
              case "MODULE_ACCESS_CONTROL":
                this.setState({
                    showModuleAccessControlPopup: true
                });
                break;
              case "DROPDOWN_MANAGEMENT":
                this.setState({
                  showDropdownManagementPopup: true
              });
                break;
            default:
                RouteManager.navigateToPage(url);
                break;
        }
    }
  }

  showOrgSelectPopup() {
    this.setState({
      showSelectOrgPopUp: true,
    });
  }

  async copySelectedValue(value) {
    try {
      await navigator.clipboard.writeText(value);
      showToast("Copied", TOAST_TYPE.DEFAULT);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  getCard(setting) {
    return (
      <>
        <div
          className="bg-white border-radius-m border-m p-l mr-xl mb-xl column border-box shadow-s cursor-hand mobile-parent-width"
          style={{ minWidth: 330, width: "23%", minHeight: "220px" }}
          onClick={() => {
            // this.routeToPage(setting.url, setting.navigateTo, setting);
          }}
        >
          <div className="row">
            <DKIcon src={setting.icon} className="" />
            <DKLabel text={setting.iconTitle} className="ml-s fw-m fs-m" />
            {setting.hasInfo && (
              <div
                className="d-flex ellipsis"
                style={{
                  alignItems: "center",
                  width: "max-content",
                }}
              >
                {setting.infoObject.isCashFreeConnected && (
                  <div className="d-flex pl-s fw-m">
                    <DKTooltipWrapper
                      content="Cashfree is configured"
                      tooltipClassName="warning-tooltip-prop"
                    >
                      <DKStatus color="bg-green" />
                    </DKTooltipWrapper>
                  </div>
                )}
                {!setting.infoObject.isCashFreeConnected && (
                  <div className="d-flex pl-s fw-m">
                    <DKTooltipWrapper
                      content="Cashfree is not configured"
                      tooltipClassName="warning-tooltip-prop"
                    >
                      <DKStatus color="bg-gray" />
                    </DKTooltipWrapper>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="row">
            <DKLabel text={setting.title} className="fw-m mt-m fs-m" />
            {setting.hasInfo && setting.infoObject && (
              <DKTooltipWrapper
                content={setting.infoObject.infoText}
                tooltipClassName="warning-tooltip-prop"
              >
                <DKIcon src={ic_info_warning} className="ic-s mt-m pl-xs" />
              </DKTooltipWrapper>
            )}
          </div>
          {setting.hasInfo && (
            <div className="ellipsis">
              {setting.infoObject && (
                <>
                  <div className="">
                    <div className="d-flex" style={{ alignItems: "baseline" }}>
                      <DKLabel text={"WhiteList IP:"} className="mt-s" />
                      <div
                        className="pl-xs fw-m"
                        style={{ textAlign: "start" }}
                      >
                        {setting.infoObject.whiteListIp.map((ip, index) => {
                          return (
                            <u key={ip} style={{ display: "flex" }}>
                              <a
                                href={setting.infoObject.ipRedirectUrl}
                                target="_blank"
                                className="text-app-color"
                              >
                                {ip}
                              </a>
                              <div>
                                <DKTooltipWrapper
                                  content="Copy"
                                  tooltipClassName="warning-tooltip-prop width-tooltip-copy "
                                >
                                  <DKIcon
                                    src={ic_copy}
                                    className="ic-xs pl-s"
                                    onClick={() => this.copySelectedValue(ip)}
                                  />
                                </DKTooltipWrapper>
                              </div>
                            </u>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="d-flex" style={{ alignItems: "baseline" }}>
                      <DKLabel text={"Webhooks URL:"} className="mt-s" />
                      <div
                        className="ellipsis pl-xs fw-m text-blue"
                        style={{ width: "35%" }}
                      >
                        <DKTooltipWrapper
                          content={setting.infoObject.webhooks}
                          tooltipClassName="warning-tooltip-prop ellipsis"
                          className="ellipsis"
                        >
                          <u>
                            <a
                              href={setting.infoObject.webhooksRedirectUrl}
                              target="_blank"
                              className="text-app-color"
                            >
                              {setting.infoObject.webhooks}
                            </a>
                          </u>
                        </DKTooltipWrapper>
                      </div>
                      <div className="fw-m">
                        <DKTooltipWrapper
                          content="Copy"
                          tooltipClassName="warning-tooltip-prop width-tooltip-copy "
                        >
                          <DKIcon
                            src={ic_copy}
                            className="ic-xs pl-s"
                            onClick={() =>
                              this.copySelectedValue(
                                setting.infoObject.webhooks
                              )
                            }
                          />
                        </DKTooltipWrapper>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {!setting.hasInfo && (
            <DKLabel
              text={setting.description}
              className="text-dark-gray mt-xs"
              style={{ height: 40 }}
            />
          )}
          <div
            className="row-reverse"
            style={{ justifyContent: "space-between", marginTop: "auto" }}
          >
            <div>
              <DKButton
                title={setting.buttonTitle}
                className="align-self-end bg-gray1 border-m mt-xl"
                icon={DKIcons.ic_arrow_right2}
                isReverse={true}
                onClick={() => {
                  this.routeToPage(
                    setting.url,
                    setting.navigateTo,
                    setting.redirectTo
                  );
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getHelpSection() {
    return (
      <div className="column bg-deskera-secondary p-r border-radius-m border-m mt-m banner-holder">
        <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about People+ setting options.' />

        <div className="row mt-r ml-l">
          <DKButton
            className="border-m bg-white"
            title="Read"
            onClick={AppManager.showComingSoonWarning}
          />
          <DKButton
            className="border-m ml-r bg-white"
            title="Watch"
            onClick={AppManager.showComingSoonWarning}
          />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getFooter() {
    return (
      <div className="mt-xl parent-width mb-xxl">
        <DKLabel className="text-align-center fw-m" text="Contact us" />
        <DKLabel
          className="text-align-center mt-s text-gray"
          text="If you have any other query or problem please feel free to contact us"
        />
        <div className="cursor-hand" onClick={this.showFeedbackPopup}>
          <DKLabel
            className="text-align-center text-blue mt-r"
            text="<u>care@deskera.com</u>"
          />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  showFeedbackPopup = () => {
    this.setState({ needFeedbackPopup: true });
  };
  hideFeedbackPopup = () => {
    this.setState({ needFeedbackPopup: false });
  };

  hideSelectOrgPopup = () => {
    this.setState({ showSelectOrgPopUp: false });
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
}
